import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { STATICS } from 'statics'
import { setDrawer } from 'slices/drawer'
import { BILLS_TAGS, DRAWER_KEY, FIREBASE_EVENTS } from 'app-constants'
import { useFirebaseEvent } from 'hooks'
import { InvoiceCard } from '../invoice'
import {
  DEFAULT_TITLE_PREFIX,
  DEFAULT_TITLE_SUFIX,
  INVOICES_BY_PAGE,
  WITHOUT_SLIPS_TEXTS,
} from '../../constants'
import './style.scss'

export function InvoicesList() {
  const [itemsToShow, setItemsToShow] = useState(INVOICES_BY_PAGE)
  const { bankSlips } = useSelector(state => state.financial)
  const [pending, setPending] = useState([])
  const dispatch = useDispatch()
  const { sendEvent } = useFirebaseEvent()

  useEffect(() => {
    function isNotInNegotiation(bankSlip) {
      const { tags } = bankSlip

      const isInNegotiation = tags.includes(BILLS_TAGS.IN_NEGOTIATION)

      return !isInNegotiation
    }

    function updatePending() {
      const { content } = bankSlips
      if (!content) return null

      const pendingNotInNegotiation = content.filter(isNotInNegotiation)
      setPending(pendingNotInNegotiation)
    }

    updatePending()
  }, [bankSlips])

  function handleTryAgainClick() {
    sendEvent(FIREBASE_EVENTS.CLICK_ON_TRY_AGAIN_GIGA_HELP)
    dispatch(setDrawer(DRAWER_KEY.FAQ))
  }

  function handleSeeMoreClick() {
    setItemsToShow(prev => prev + INVOICES_BY_PAGE)
  }

  function getTitle() {
    const hasInvoices = pending.length
    const title = hasInvoices
      ? `${DEFAULT_TITLE_PREFIX}${pending.length}${DEFAULT_TITLE_SUFIX}`
      : WITHOUT_SLIPS_TEXTS

    return <span className='title'>{title}</span>
  }

  function getInvoicesToShow() {
    return pending.slice(0, itemsToShow)
  }

  function renderInvoices() {
    const invoicesToShow = getInvoicesToShow()

    return invoicesToShow.map(slip => <InvoiceCard key={slip.id} slip={slip} />)
  }

  function renderSeeMoreButton() {
    const hasMoreInvoicesToShow = pending.length > itemsToShow

    if (!hasMoreInvoicesToShow) return null

    return (
      <button className='see-more-button' type='button' onClick={handleSeeMoreClick}>
        Ver mais <STATICS.ARROW_DOWN_BLACK />
      </button>
    )
  }

  function renderInvoiceContainer() {
    const hasInvoices = pending.length

    if (!hasInvoices) return null

    return (
      <div className='container-invoices'>
        {renderInvoices()}
        {renderSeeMoreButton()}
      </div>
    )
  }

  return (
    <div className='holder-invoices-list'>
      <div className='container-invoices-list'>
        <div className='container-title'>
          <STATICS.STAR /> {getTitle()}
        </div>
        {renderInvoiceContainer()}
        <div className='container-try-again'>
          <span className='title'>Não encontrou o que precisava?</span>
          <span className='subtitle'>Tente uma nova busca</span>
          <button type='button' onClick={handleTryAgainClick} className='button'>
            Buscar novamente <STATICS.ARROW_NEXT />
          </button>
        </div>
      </div>
    </div>
  )
}
